import React, { Component } from 'react'

import { MainHeader, MainFooter } from '../Components'

import FolderView from './_FolderView'

import './Css/PageManagement.css';


class PageManagement extends Component{
    render(){
        return (
            <div className="InnerApp">
                <MainHeader user={this.props.user}/>
                <section className="UploadLanding hero">
                    <div className="hero-body">
                    </div>
                </section>
                <FolderView user={this.props.user} setUser={this.props.setUser}></FolderView>
                <MainFooter />            
            </div>
            
        )
    }
}
export default PageManagement




// WEBPACK FOOTER //
// ./src/PageManagement/_PageManagement.js